export const campaignCategories = [
  "Tümü",
  "Lazer Epilasyon",
  "Cilt Bakımı",
  "Kaş & Kirpik",
  "Kalıcı Makyaj",
  "Vücut Bakımı",
  "Simülasyon & Kamuflaj",
];

export const featuredCampaigns = [
  {
    id: "lazer-tum-vucut",
    badge: "SONBAHAR KAMPANYASI",
    title: "TÜM VÜCUT",
    titleLine2: "LAZER EPİLASYON",
    priceLabel: "SEANS",
    price: "1.500 TL",
    note: "Tüm vücut bölgesi için tek seans kampanya fiyatı.",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/bc2b92b2-6e6f-4155-bb8e-64d6610aa23f_compressed_tum_vucut1500.webp",
    buttonLabel: "BU KAMPANYA İÇİN BİLGİ AL",
    message:
      "Merhaba, Tüm Vücut Lazer Epilasyon 1.500 TL sonbahar kampanyası hakkında bilgi ve randevu almak istiyorum.",
  },
  {
    id: "lazer-kol-bacak-koltuk",
    badge: "SONBAHAR KAMPANYASI",
    title: "TÜM KOL + TÜM BACAK",
    titleLine2: "+ KOLTUK ALTI LAZER EPİLASYON",
    priceLabel: "SEANS",
    price: "1.000 TL",
    note: "Üç bölge tek kampanyada birleşiyor.",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/0c436b9b-8954-4d44-8a41-6c13b89185c1_compressed_tumcb1000.webp",
    buttonLabel: "BU KAMPANYA İÇİN BİLGİ AL",
    message:
      "Merhaba, Tüm Kol + Tüm Bacak + Koltuk Altı 1.000 TL lazer epilasyon kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "lazer-yuz-bolgesi",
    badge: "SONBAHAR KAMPANYASI",
    title: "YÜZ BÖLGESİ",
    titleLine2: "LAZER EPİLASYON",
    priceLabel: "SEANS",
    price: "500 TL",
    note: "Yüz bölgesi için tek seans kampanya fiyatı.",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/751144a0-6dfe-4cab-bfbe-f4e9ea83724d_compressed_yuzbolgesi500.webp",
    buttonLabel: "BU KAMPANYA İÇİN BİLGİ AL",
    message:
      "Merhaba, Yüz Bölgesi Lazer Epilasyon 500 TL kampanyası hakkında bilgi ve randevu almak istiyorum.",
  },
];

export const allCampaigns = [
  {
    id: "lazer-1",
    category: "Lazer Epilasyon",
    title: "Tüm Vücut Lazer Epilasyon",
    price: "Seans 1.500 TL",
    icon: "ri-flashlight-line",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/bc2b92b2-6e6f-4155-bb8e-64d6610aa23f_compressed_tum_vucut1500.webp",
    message:
      "Merhaba, Tüm Vücut Lazer Epilasyon 1.500 TL sonbahar kampanyası hakkında bilgi ve randevu almak istiyorum.",
  },
  {
    id: "lazer-2",
    category: "Lazer Epilasyon",
    title: "Tüm Kol + Tüm Bacak + Koltuk Altı",
    price: "Seans 1.000 TL",
    icon: "ri-flashlight-line",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/0c436b9b-8954-4d44-8a41-6c13b89185c1_compressed_tumcb1000.webp",
    message:
      "Merhaba, Tüm Kol + Tüm Bacak + Koltuk Altı 1.000 TL lazer epilasyon kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "lazer-3",
    category: "Lazer Epilasyon",
    title: "Yüz Bölgesi Lazer Epilasyon",
    price: "Seans 500 TL",
    icon: "ri-flashlight-line",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/751144a0-6dfe-4cab-bfbe-f4e9ea83724d_compressed_yuzbolgesi500.webp",
    message:
      "Merhaba, Yüz Bölgesi Lazer Epilasyon 500 TL kampanyası hakkında bilgi ve randevu almak istiyorum.",
  },
  {
    id: "cilt-1",
    category: "Cilt Bakımı",
    title: "Cilt Bakımları 1.000 TL",
    price: "Her uygulama 1.000 TL",
    icon: "ri-leaf-line",
    image:
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/b833c26a-ef8e-41ea-9dba-ca0bb2cbcf6c_compressed_profcb1000.webp",
    extraImages: [
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/050fc2b5-d482-4ee5-8bc2-d34dcc737975_compressed_camcilt.webp",
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/b82c75b8-9007-436c-9b14-89dc793969f6_compressed_lekeakneodakli.webp",
      "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/441d5eb4-b0a6-4c26-9b65-da7a950fe386_compressed_100TLsonbaharkampanya.webp",
    ],
    points: [
      "Medikal Cilt Bakımı",
      "Enzim Peeling",
      "Carboxy Cilt Bakımı",
      "Cam Cilt Bakımı",
      "Anti-Aging Cilt Bakımı",
      "Leke & Akne Odaklı Cilt Bakımı",
      "Kolajen İp Dolgu Tozu",
      "İğnesiz Mezoterapi",
    ],
    note: "Kampanya kapsamındaki cilt bakımı uygulamalarının her biri 1.000 TL’dir.",
    buttonLabel: "CİLT BAKIMI İÇİN BİLGİ AL",
    message:
      "Merhaba, 1.000 TL cilt bakımı kampanyanız hakkında bilgi almak ve bana uygun bakım seçeneğini öğrenmek istiyorum.",
  },
  {
    id: "kas-1",
    category: "Kaş & Kirpik",
    title: "Kirpik & Kaş Laminasyonu",
    price: "İki İşlem 1.500 TL",
    subPrice: "Tek İşlem 1.000 TL",
    icon: "ri-eye-line",
    message:
      "Merhaba, Kirpik & Kaş Laminasyonu kampanyası (İki işlem 1.500 TL / Tek işlem 1.000 TL) hakkında bilgi almak istiyorum.",
  },
  {
    id: "kas-2",
    category: "Kaş & Kirpik",
    title: "Klasik İpek Kirpik",
    price: "1.000 TL",
    icon: "ri-eye-2-line",
    message:
      "Merhaba, Klasik İpek Kirpik 1.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "kas-3",
    category: "Kaş & Kirpik",
    title: "Altın Oran Kaş Alımı",
    price: "500 TL",
    icon: "ri-scissors-2-line",
    message:
      "Merhaba, Altın Oran Kaş Alımı 500 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "kalici-1",
    category: "Kalıcı Makyaj",
    title: "Kalıcı Makyaj",
    price: "Tek İşlem 3.000 TL",
    subPrice: "Seçeceğiniz 2 İşlem 5.000 TL",
    icon: "ri-brush-line",
    points: ["Microblading", "Kalıcı Dipliner", "Dudak Renklendirme"],
    buttonLabel: "KALICI MAKYAJ İÇİN BİLGİ AL",
    message:
      "Merhaba, Kalıcı Makyaj tek işlem 3.000 TL ve seçilecek iki işlem 5.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "vucut-1",
    category: "Vücut Bakımı",
    title: "Tüm Vücut Ağda",
    price: "1.000 TL",
    icon: "ri-drop-line",
    message: "Merhaba, Tüm Vücut Ağda 1.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "vucut-2",
    category: "Vücut Bakımı",
    title: "Meridyen & Kupa Masajı",
    price: "1.000 TL",
    icon: "ri-hand-heart-line",
    message:
      "Merhaba, Meridyen & Kupa Masajı 1.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "vucut-3",
    category: "Vücut Bakımı",
    title: "Bölgesel İncelme",
    subPrice: "G8 – 10 Seans",
    subPrice2: "+ 2 Seans Lenf Drenaj",
    price: "Toplam 5.000 TL",
    icon: "ri-body-scan-line",
    message:
      "Merhaba, G8 10 seans + 2 seans lenf drenaj 5.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "vucut-4",
    category: "Vücut Bakımı",
    title: "Vücut Şekillendirme",
    subtitle: "Toparlama & Sıkılaşma",
    price: "5 Seans 5.000 TL",
    icon: "ri-heart-pulse-line",
    message:
      "Merhaba, 5 seans vücut şekillendirme 5.000 TL kampanyası hakkında bilgi almak istiyorum.",
  },
  {
    id: "simulasyon-1",
    category: "Simülasyon & Kamuflaj",
    title: "Saç Simülasyonu",
    price: "Uygulama yapılacak bölgeye göre değerlendirilir",
    icon: "ri-user-voice-line",
    message:
      "Merhaba, simülasyon ve kamuflaj uygulamaları için bölgeye göre değerlendirme ve fiyat bilgisi almak istiyorum.",
  },
  {
    id: "simulasyon-2",
    category: "Simülasyon & Kamuflaj",
    title: "Dikiş İzi Kamuflajı",
    price: "Uygulama yapılacak bölgeye göre değerlendirilir",
    icon: "ri-first-aid-kit-line",
    message:
      "Merhaba, Dikiş İzi Kamuflajı için bölgeye göre değerlendirme ve fiyat bilgisi almak istiyorum.",
  },
  {
    id: "simulasyon-3",
    category: "Simülasyon & Kamuflaj",
    title: "Vitiligo Kamuflajı",
    price: "Uygulama yapılacak bölgeye göre değerlendirilir",
    icon: "ri-contrast-drop-2-line",
    message:
      "Merhaba, Vitiligo Kamuflajı için bölgeye göre değerlendirme ve fiyat bilgisi almak istiyorum.",
  },
  {
    id: "simulasyon-4",
    category: "Simülasyon & Kamuflaj",
    title: "Çatlak Kamuflajı",
    price: "Uygulama yapılacak bölgeye göre değerlendirilir",
    icon: "ri-scan-2-line",
    message:
      "Merhaba, Çatlak Kamuflajı için bölgeye göre değerlendirme ve fiyat bilgisi almak istiyorum.",
  },
];

export const simulationNote =
  "Simülasyon ve kamuflaj uygulamalarında fiyat, uygulama yapılacak bölgeye göre değerlendirilir.";